import { z } from "zod";

export const BenchmarkSchema = z.object({
  target: z.number().nullable(),
  peerMedian: z.number().nullable(),
  percentile: z.number().nullable(),
  distribution: z.array(z.number()),
});

// null benchmark = the website has no completed report yet, or no benchmark set.
export const BenchmarkResponseSchema = z.object({
  benchmark: BenchmarkSchema.nullable(),
  hasReport: z.boolean(),
});

export type Benchmark = z.infer<typeof BenchmarkSchema>;
export type BenchmarkResponse = z.infer<typeof BenchmarkResponseSchema>;
